import React, { useState, useRef, useEffect } from "react";
import styles from "./PaymentSection.module.css";
import { loginApi } from "../../config/loginApi";
import { signupApi } from "../../config/signupApi";
import { createVisaApplicationApi } from "../../config/createVisaApplicationApi";
import { paymentPopupApi } from "../../config/paymentPopupApi";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";
import { connect } from "react-redux";
import changeLogin from "../../store/Actions/LoginAction";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Radio from "@material-ui/core/Radio";

import bank1 from "../../assets/images/bank1.png";
import bank2 from "../../assets/images/bank2.png";
import bank3 from "../../assets/images/bank3.png";
import bank4 from "../../assets/images/bank4.PNG";

function PaymentSection(props) {
  const login = props.login;

  const loginBtn = useRef();
  const [loading, setLoading] = useState(false);

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const signupBtn = useRef();
  const [loading1, setLoading1] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [bank, setBank] = useState("");

  const payBtn = useRef();
  const [loading2, setLoading2] = useState(false);

  const country = props.details.country;
  const country_id = props.details.country_id;
  const persons = props.details.persons;
  const total = props.details.total;
  const visa_type = props.details.visa_type;
  const visa_id = props.details.visa_id;
  const embassy_fees = props.details.embassy_fees;
  const service_fees = props.details.service_fees;
  const service = props.details.service;
  const date1 = moment(new Date(props.details.travel_date));
  const travel_date = date1.format("DD/MM/YYYY");
  const date2 = moment(new Date(props.details.return_date));
  const return_date = date2.format("DD/MM/YYYY");

  const travel_date1 = date1.toISOString();
  const return_date1 = date2.toISOString();

  const [id, setId] = useState("");
  const [token, setToken] = useState("");

  const history = useHistory();

  useEffect(() => {
    if (country === undefined) {
      history.goBack();
    }

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      setId(item.value.user_data._id);
      setToken(item.value.token);
    }
    getWithExpiry("userData");
  }, [login]);

  // const emailValidation = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;
  const emailValidation = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const passwordValidation = /^[A-Za-z[0-9]\w{7,}$/;
  const phoneValidation = /^(\+|\d)[0-9]{7,16}$/;
  const nameValidation = /^[a-zA-Z ]{2,30}$/;

  const loginClick = (e) => {
    e.preventDefault();
    if (emailValidation.test(loginEmail) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Enter Valid Email Address!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (passwordValidation.test(loginPassword) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Enter Valid Password!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      setLoading(true);
      loginBtn.current.setAttribute("disabled", "disabled");
      const login = async () => {
        const login = await loginApi(loginEmail, loginPassword);

        if (login.error) {
          if (
            login.error.response.data.message ===
            "Account details supplied is incorrect, please check and try again"
          ) {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                Wrong Password!
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );

            setLoading(false);
            loginBtn.current.removeAttribute("disabled");

            setLoginPassword("");
          } else {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {login.error.response.data.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );

            setLoading(false);
            loginBtn.current.removeAttribute("disabled");
          }
        } else if (login.data) {
          toast.success(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BsCheckAll size="30" style={{ marginRight: "10px" }} />
              Login Successfully
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setLoginEmail("");
          setLoginPassword("");

          setLoading(false);
          loginBtn.current.removeAttribute("disabled");

          props.ChangeLogin(true);
          window.scrollTo(0, 0);
        }
      };
      login();
    }
  };

  const signupClick = (e) => {
    e.preventDefault();
    if (nameValidation.test(firstName) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Please Enter Valid First Name!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (nameValidation.test(lastName) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Please Enter Valid Last Name!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (phoneValidation.test(phone) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Enter Valid Phone Number!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (emailValidation.test(email) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Enter Valid Email Address!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (passwordValidation.test(password) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Enter Valid Password!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      setLoading1(true);
      signupBtn.current.setAttribute("disabled", "disabled");
      const signup = async () => {
        const signup = await signupApi(
          firstName,
          lastName,
          phone,
          email,
          password
        );

        if (signup.error) {
          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              {signup.error.response.data.message}
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );

          setLoading1(false);
          signupBtn.current.removeAttribute("disabled");
        } else if (signup.data) {
          const login = await loginApi(email, password);
          toast.success(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BsCheckAll size="30" style={{ marginRight: "10px" }} />
              SignUp Successfully
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );

          setFirstName("");
          setLastName("");
          setEmail("");
          setPassword("");
          setPhone("");

          setLoading1(false);
          signupBtn.current.removeAttribute("disabled");
          props.ChangeLogin(true);
          window.scrollTo(0, 0);
        }
      };
      signup();
    }
  };

  const pay = () => {
    if (login === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          You Must Login First!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (bank === "") {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Payment Method!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      setLoading2(true);
      payBtn.current.setAttribute("disabled", "disabled");
      const visa = async () => {
        const visa = await createVisaApplicationApi(
          {
            travellers_count: persons,
            owner: id,
            destination: country_id,
            visa_package: visa_id,
            return_date: return_date1,
            departure_date: travel_date1,
            cost: {
              embassy_fee: embassy_fees,
              service_charges: service_fees,
              total_cost: total,
            },
            plan_type: service.toUpperCase(),
            payment_method: "CARD",
            payment_gateway: bank.toUpperCase(),
            created_via: "HOMEPAGE",
          },
          token
        );

        if (visa.error) {
          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              {visa.error.response.data.message}
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setLoading2(false);
          payBtn.current.removeAttribute("disabled");
        } else if (visa.data) {



          const payment = async () => {
            const payment = await paymentPopupApi(
              visa.data.data._id,
              token,
              visa.data.data.payment_gateway.toLowerCase(),
              `http://visapro1.netlify.app/payment/thanks?provider=${bank}`
              // `http://localhost:3000/payment/thanks?provider=${bank}`

            );

            if (payment.error) {
              toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{ marginRight: "10px" }} />
                  {payment.error.response.data.message}
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
              setLoading2(false);
              payBtn.current.removeAttribute("disabled");
            } else if (payment.data) {
              window.location.replace(payment.data.data.link)
              setLoading2(false);
              payBtn.current.removeAttribute("disabled");
            }
          };
          payment();
        }
      };
      visa();
    }
  };

  return (
    <div>
      {login ? (
        <div className={styles.topBox}>
          <div className={styles.totalCont}>
            <h1 className={styles.totalTittle}>Booking details</h1>
            <div className={styles.totalBox}>
              <div className={styles.eachCont}>
                <h1 className={styles.eachName}>Destination</h1>
                <h1 className={styles.eachValue}>{country}</h1>
              </div>
              <div className={styles.eachCont}>
                <h1 className={styles.eachName}>Visa type</h1>
                <h1 className={styles.eachValue}>{visa_type}</h1>
              </div>
              <div className={styles.eachCont}>
                <h1 className={styles.eachName}>Travel date</h1>
                <h1 className={styles.eachValue}>{travel_date}</h1>
              </div>
              <div className={styles.eachCont}>
                <h1 className={styles.eachName}>Priority</h1>
                <h1 className={styles.eachValue}>{service}</h1>
              </div>
              <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Service charges</h1>
                  <h1 className={styles.eachValue}>₦ {service_fees.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Embassy visa fees</h1>
                  <h1 className={styles.eachValue}>₦ {embassy_fees.toLocaleString()}</h1>
                </div>
              <div className={styles.eachCont}>
                <h1 className={styles.eachName}>No of persons</h1>
                <h1 className={styles.eachValue}>{persons}</h1>
              </div>
            </div>
            <hr />
            <div className={styles.totalEnd}>
              <h1 className={styles.total}>Total</h1>
              <h1 className={styles.total}>₦ {total.toLocaleString()}</h1>
            </div>
          </div>

          <div className={styles.paymentBox}>
            <h1 className={styles.loginHeading}>Select payment method</h1>
            <div className={styles.selectMethodBox}>
              <button
                className={styles.selectBtn}
                onClick={() => {
                  setBank("interSwitch");
                }}
              >
                <img src={bank1} alt="Bank 1" className={styles.btnImage} />
                <Radio
                  onChange={() => {
                    setBank("interSwitch");
                  }}
                  checked={bank === "interSwitch"}
                  value="normal"
                  color="default"
                  name="bank"
                />
              </button>
              <button
                className={styles.selectBtn}
                onClick={() => {
                  setBank("paystack");
                }}
              >
                <img src={bank2} alt="Bank 2" className={styles.btnImage} />
                <Radio
                  onChange={() => {
                    setBank("paystack");
                  }}
                  checked={bank === "paystack"}
                  value="normal"
                  color="default"
                  name="bank"
                />
              </button>
              <button
                className={styles.selectBtn}
                onClick={() => {
                  setBank("flutterwave");
                }}
              >
                <img src={bank3} alt="Bank 3" className={styles.btnImage} />
                <Radio
                  onChange={() => {
                    setBank("flutterwave");
                  }}
                  checked={bank === "flutterwave"}
                  value="normal"
                  color="default"
                  name="bank"
                />
              </button>
              <button
                className={styles.selectBtn}
                onClick={() => {
                  setBank("manual");
                }}
              >
                <img src={bank4} alt="Bank 4" className={styles.btnImage} />
                <Radio
                  onChange={() => {
                    setBank("manual");
                  }}
                  checked={bank === "manual"}
                  value="normal"
                  color="default"
                  name="bank"
                />
              </button>
            </div>
            <div className={styles.signUpbtnCont}>
              <button
                className={styles.paybtn}
                onClick={() => pay()}
                ref={payBtn}
              >
                {loading2 ? (
                  <div class="spinner-border" role="status"></div>
                ) : (
                  `Pay NGN ${total.toLocaleString()}`
                )}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.main}>
          <div className={styles.mainBox}>
            <div>
              <div className={styles.login}>
                <h1 className={styles.loginHeading}>Existing User</h1>
                <div>
                  <form
                    onSubmit={(e) => loginClick(e)}
                    className={styles.loginBox}
                  >
                    <input
                      type="email"
                      className={styles.loginInput}
                      placeholder="Email"
                      value={loginEmail}
                      onChange={(e) => {
                        setLoginEmail(e.target.value);
                      }}
                    />
                    <input
                      type="password"
                      className={styles.loginInput}
                      placeholder="Password"
                      value={loginPassword}
                      onChange={(e) => {
                        setLoginPassword(e.target.value);
                      }}
                    />
                    <button
                      type="submit"
                      className={styles.loginBtn}
                      ref={loginBtn}
                    >
                      {loading ? (
                        <div class="spinner-border" role="status"></div>
                      ) : (
                        "Proceed"
                      )}
                    </button>
                  </form>
                </div>
              </div>
              <h1 className={styles.centerHead}>Or continue as a new user</h1>
              <div className={styles.signup}>
                <h1 className={styles.loginHeading}>New User</h1>
                <form onSubmit={(e) => signupClick(e)}>
                  <div className={styles.signupLittle}>
                    <input
                      type="text"
                      className={styles.signUpInput}
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                    />
                    <input
                      type="text"
                      className={styles.signUpInput}
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                    />
                  </div>
                  <hr className={styles.line} />
                  <div className={styles.signUpBig}>
                    <input
                      type="tel"
                      className={styles.signUpInputL}
                      placeholder="phone"
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                    />
                  </div>
                  <hr className={styles.line} />
                  <div className={styles.signupLittle}>
                    <input
                      type="email"
                      className={styles.signUpInput}
                      placeholder="Email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    <input
                      type="password"
                      className={styles.signUpInput}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                  </div>
                  <div className={styles.signUpbtnCont}>
                    <button
                      type="submit"
                      className={styles.signUpbtn}
                      ref={signupBtn}
                    >
                      {loading1 ? (
                        <div class="spinner-border" role="status"></div>
                      ) : (
                        "Proceed"
                      )}
                    </button>
                  </div>
                </form>
              </div>
              <div className={styles.paymentBox}>
                <h1 className={styles.loginHeading}>Select payment method</h1>
                <div className={styles.selectMethodBox}>
                  <button
                    className={styles.selectBtn}
                    onClick={() => {
                      setBank("interSwitch");
                    }}
                  >
                    <img src={bank1} alt="Bank 1" className={styles.btnImage} />
                    <Radio
                      onChange={() => {
                        setBank("interSwitch");
                      }}
                      checked={bank === "interSwitch"}
                      value="normal"
                      color="default"
                      name="bank"
                    />
                  </button>
                  <button
                    className={styles.selectBtn}
                    onClick={() => {
                      setBank("paystack");
                    }}
                  >
                    <img src={bank2} alt="Bank 2" className={styles.btnImage} />
                    <Radio
                      onChange={() => {
                        setBank("paystack");
                      }}
                      checked={bank === "paystack"}
                      value="normal"
                      color="default"
                      name="bank"
                    />
                  </button>
                  <button
                    className={styles.selectBtn}
                    onClick={() => {
                      setBank("flutterwave");
                    }}
                  >
                    <img src={bank3} alt="Bank 3" className={styles.btnImage} />
                    <Radio
                      onChange={() => {
                        setBank("flutterwave");
                      }}
                      checked={bank === "flutterwave"}
                      value="normal"
                      color="default"
                      name="bank"
                    />
                  </button>
                  <button
                    className={styles.selectBtn}
                    onClick={() => {
                      setBank("manual");
                    }}
                  >
                    <img src={bank4} alt="Bank 4" className={styles.btnImage} />
                    <Radio
                      onChange={() => {
                        setBank("manual");
                      }}
                      checked={bank === "manual"}
                      value="normal"
                      color="default"
                      name="bank"
                    />
                  </button>
                </div>
                <div className={styles.signUpbtnCont}>
                  <button
                    className={styles.paybtn}
                    onClick={() => pay()}
                    ref={payBtn}
                  >
                    {loading2 ? (
                      <div class="spinner-border" role="status"></div>
                    ) : (
                      `Pay NGN ${total.toLocaleString()}`
                      // .toLocaleString()
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div className={styles.totalCont}>
              <h1 className={styles.totalTittle}>Booking details</h1>
              <div className={styles.totalBox}>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Destination</h1>
                  <h1 className={styles.eachValue}>{country}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Visa type</h1>
                  <h1 className={styles.eachValue}>{visa_type}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Travel date</h1>
                  <h1 className={styles.eachValue}>{travel_date}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Priority</h1>
                  <h1 className={styles.eachValue}>{service}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Service charges</h1>
                  <h1 className={styles.eachValue}>₦ {service_fees.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Embassy visa fees</h1>
                  <h1 className={styles.eachValue}>₦ {embassy_fees.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>No of persons</h1>
                  <h1 className={styles.eachValue}>{persons}</h1>
                </div>
              </div>
              <hr />
              <div className={styles.totalEnd}>
                <h1 className={styles.total}>Total</h1>
                <h1 className={styles.total}>₦ {total.toLocaleString()}</h1>
                {/* .toLocaleString() */}
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  login: state.Login.login,
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect(mapStateToProps, mapDispatchToProp)(PaymentSection);
